var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainflip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 34,
    viewBox: "0 0 204 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_699_896",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 204,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.421 0H0.579102V34H203.421V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_699_896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1793 26.5489C61.6913 26.5489 65.6048 23.4494 65.6048 18.2837V17.7827H59.5311V18.2837C59.5311 20.4752 58.4979 21.3518 55.2733 21.3518C51.3285 21.3518 50.2641 20.4126 50.2641 16.5618C50.2641 12.7109 51.3285 11.7717 55.2733 11.7717C58.4979 11.7717 59.5311 12.6483 59.5311 14.8398V15.3408H65.6048V14.8711C65.6048 9.7054 61.6913 6.60596 55.1793 6.60596C48.4482 6.60596 44.4722 10.5507 44.4722 16.5931C44.4722 22.6354 48.4482 26.5489 55.1793 26.5489Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4611 26.2676V18.9729H81.4777V26.2676H86.9565V6.88818H81.509V14.0889H72.4924V6.88818H67.0449V26.2676H72.4611Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.625 26.2676L95.1278 22.6672H104.332L105.804 26.2676H112.065L103.675 6.88818H95.8791L87.52 26.2676H93.625ZM98.3211 15.0595L99.5734 11.8035H99.9491L101.233 15.0595L102.36 17.7832H97.1941L98.3211 15.0595Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.108 26.2676V6.88818H112.66V26.2676H118.108Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.277 26.2675V18.6911L125.058 14.9968H125.434L127.907 18.8163L133.636 26.2988H139.428V6.91943H133.981V14.4019L134.231 18.6285H133.855L131.006 14.1828L125.621 6.91943H119.83V26.2988H125.277V26.2675Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.597 26.2675V19.5364H158.056V14.6837H146.597V11.8034H158.494V6.91943H141.15V26.2988H146.597V26.2675Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.559 26.2676V21.3836H165.351V6.88818H159.903V26.2676H176.559Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.447 26.2676V6.88818H177.999V26.2676H183.447Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.616 26.2676V21.3836H195.907C200.509 21.3836 203.389 18.7224 203.389 14.1202C203.389 9.51802 200.509 6.88818 195.907 6.88818H185.168V26.2676H190.616ZM195.312 11.7722C197.222 11.7722 198.005 12.1479 198.005 14.1202C198.005 16.1239 197.222 16.4996 195.312 16.4996H190.616V11.7722H195.312Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0802 0V14.6832C35.0802 17.2818 34.2662 19.8177 32.7634 21.9153C32.2938 22.5727 31.7616 23.1676 31.198 23.6998L31.1667 23.7311H24.279V10.1123H17.8923H11.443H10.8794H4.49268L4.5866 10.0184L10.0028 4.94659L12.0065 3.09945C14.2606 0.970532 17.047 0 20.1151 0H35.0802Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1666 23.7629L31.1353 23.7942L30.7596 24.1386L29.3821 25.4535L24.4041 30.1183L23.9345 30.5566C21.6804 32.6542 18.7062 33.8126 15.6693 33.8126H0.579102V27.238L0.610409 23.7316L0.641718 19.0668C0.673026 15.6542 2.05056 12.4296 4.52385 10.1128H10.8793H10.9106V23.7316L31.1666 23.7629Z",
    fill: "#A5A5A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainflip);
export default __webpack_public_path__ + "static/media/chainflip.7207a382b9214fa2199776cda2e47806.svg";
export { ForwardRef as ReactComponent };